<template>
  <div id="app">
    <app-header></app-header>
    <main :class="$store.state.activedPath === '/index' ? 'indexMain' : 'main'">
      <router-view/>
    </main>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  components: {
    'app-header': Header,
    'app-footer': Footer
  },
  watch: {
    '$route' (to) {
      this.setActivedPath(this.$route.path)
    }
  },
  methods: {
    ...mapMutations(['setActivedPath'])
  },
  mounted () {
    this.setActivedPath(this.$route.path)
  }
}
</script>

<style lang="scss">
@import './style/index.scss';
#app {
  // 首页轮播箭头 1180 + 148 + 148
  @media screen and (min-width: $min-width-standard){
    // min-width: 1476px;
    min-width: 1180px;
  }
  background-color: $background-color;
  font-family: PingFangSC-Regular, "Microsoft YaHei", 微软雅黑;
  color: #0D1A26;
  font-size: 16px;
  // line-height: 1;
}

.main {
  padding-top: 90px;
  @media screen and (max-width: $max-width-standard) {
    padding-top: 44px;
  }
}

.indexMain {
  padding-top: 90px;
  @media screen and (max-width: $max-width-standard) {
    padding-top: 44px;
  }
}

p, span, body, ul, button {
  margin: 0;
  padding: 0;
}

a {
  color: rgba(255, 255, 255, 0.65);
  text-decoration: none;
}

input {
  outline:none;
}

input::placeholder{
  color:#BEC1CC;
}

div, section, input {
  box-sizing: border-box;
  -moz-box-sizing : border-box ;
  -webkit-box-sizing : border-box ;
}

button {
  border: none;
  background-color: transparent;
  outline: none;
}

button[disabled] {
  cursor: not-allowed;
}
</style>
